/**
 * The bottom-right corner on desktop, shared by the buttons that float there:
 * Abekus AI's orb and the employer support bubble. They sit side by side,
 * bottoms aligned, the support bubble rightmost. Each says what it needs as a
 * CSS variable on <html>, so neither has to know the other's component.
 */
export const CORNER_GAP = 24;
/** Between the two buttons when both are there. */
export const CORNER_SPACING = 12;

// How far above the corner both sit: over a page's own action bar.
const RAISE = '--corner-raise';
// The room the support bubble takes in the corner, the orb sitting left of it.
const HELD = '--corner-held';

/** Where a corner button's bottom sits. */
export const cornerBottom = `calc(${CORNER_GAP}px + var(${RAISE}, 0px))`;
/** Where the orb's right edge sits: left of the support bubble when it's there. */
export const orbRight = `calc(${CORNER_GAP}px + var(${HELD}, 0px))`;

const setCornerVar = (name: string, px: number | null) => {
  const { style } = document.documentElement;
  if (px === null) style.removeProperty(name);
  else style.setProperty(name, `${px}px`);
};

/** Lift both buttons over a page's action bar; null puts them back. */
export const raiseCorner = (px: number | null) => setCornerVar(RAISE, px);

/** Keep this much of the corner for the support bubble; null gives it back. */
export const holdCorner = (px: number | null) => setCornerVar(HELD, px);
